module.exports = __webpack_public_path__ + "img/chevron-left.29a2ca12.svg";